import { render, staticRenderFns } from "./dashlet-publish.vue?vue&type=template&id=3c479b50"
import script from "./dashlet-publish.vue?vue&type=script&lang=js"
export * from "./dashlet-publish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports